/**
 * @module Cookie
 * @description Utils for cookies
 */

/**
 * @function getCookies
 * @description Retrieve a cookie
 */
export const getCookies = () => {
  if (typeof document === "undefined") return {};

  const pairs = document.cookie.split(";");
  const cookies = {};

  for (let i = 0; i < pairs.length; i += 1) {
    const pair = pairs[i].split("=");
    cookies[pair[0].trim()] = unescape(pair[1]);
  }

  return cookies;
};

/**
 * @function getCookie
 * @description Retrieve a cookie
 */
export const getCookie = (name) => {
  const cookies = getCookies();
  const cookie = Object.keys(cookies).filter((key) => key === name);

  return cookies[cookie];
};

/**
 * @function deleteCookie
 * @description Delete a cookie
 */
export const deleteCookie = (name) => {
  const domain = new URL(window.location.href);
  const { hostname } = domain;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const domainAttr = isLocalhost ? "" : "domain=.frontier.com;";

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${domainAttr}`;
};

/**
 * @function setCookie
 * @description Set a cookie
 */
export const setCookie = (name, value, exmins, options = {}) => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  const d = new Date();
  const domain = new URL(window.location);
  const { hostname } = domain;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  if (exmins !== 0) {
    d.setTime(d.getTime() + exmins * 60 * 1000);
  }

  const expires = `expires=${d.toUTCString()}`;
  const domainAttr = isLocalhost
    ? ""
    : `domain=${options.domain || ".frontier.com"};`;
  const secureAttr = options.secure && !isLocalhost ? "Secure;" : "";
  const sameSiteAttr = options.sameSite ? `SameSite=${options.sameSite};` : "";
  const cookieString = [
    `${name}=${value};`,
    exmins === 0 ? "" : `${expires};`,
    "path=/;",
    domainAttr,
    secureAttr,
    sameSiteAttr,
  ].join("");

  if (options?.otGroup) {
    const onConsentReady = () => {
      const allowed = cohesion?.consent("list")?.includes(options.otGroup);
      if (!allowed) return deleteCookie(name);
      document.cookie = cookieString;
    };

    cohesion("consent:ready", onConsentReady);
    cohesion("consent:changed", onConsentReady);
  } else {
    document.cookie = cookieString;
  }
};
